const CartService = require('@/libraries/DigiTickets/Cart/CartService');
const StashedCart = require('@/lib/StashedCarts/StashedCart');

/**
 * @constructor
 *
 * @param $injector
 * @param currentDevice
 * @param hydrator
 * @param {UserService} userService
 */
const CartStashHelper = function (
    $injector,
    currentDevice,
    hydrator,
    userService
) {
    this.$injector = $injector;

    /**
     * @type {CurrentDevice}
     */
    this.currentDevice = currentDevice;

    /**
     * @type {UserService}
     */
    this.userService = userService;

    /**
     * @type {Hydrator}
     */
    this.hydrator = hydrator;
};

CartStashHelper.prototype = {
    /**
     * Create a StashedCart from the current cart in the CartService. It doesn't actually stash it.
     *
     * @param {CartService} cartService
     *
     * @returns {StashedCart}
     */
    cartToStash(cartService) {
        let stashedCart = new StashedCart();
        stashedCart.currentCart = cartService.currentCart.toSerializable();
        stashedCart.deviceID = this.currentDevice.getDeviceId();
        stashedCart.stashDatetime = new Date();
        stashedCart.thirdPartyID = cartService.currentCart.thirdPartyID; // TODO: Remove and just use thirdPartyRef
        stashedCart.thirdPartyRef = cartService.currentCart.thirdPartyRef;
        stashedCart.totalValue = cartService.currentCart.getTotalDue();
        stashedCart.userID = this.userService.currentUser.ID;
        stashedCart.username = this.userService.currentUser.username;

        return stashedCart;
    },

    /**
     * @param {StashedCart} stashedCart
     *
     * @return {Promise<Order>}
     */
    stashToOrder: async function stashToOrder(stashedCart) {
        // We already have the ability to convert a StashedCart to a Cart, and a Cart to an Order, so do it that
        // way instead of inventing a way to do it directly.
        /** @type {CartService} */
        let cartService = this.$injector.instantiate(CartService);

        await cartService.populateFromStash(stashedCart);

        let order = cartService.toOrder();

        // Set the stash date as the order date
        order.date = stashedCart.stashDatetime;

        return order;
    },

    /**
     * Helper function to rearrange the data received for a stashed cart from the API.
     * It contains all the expected information, but some properties are extracted from the 'stashedCartData'
     * property.
     *
     * @param {object} data
     *
     * @returns {StashedCart}
     */
    createStashedCartFromRemoteData: function createStashedCartFromRemoteData(data) {
        let stashedCart = new StashedCart();

        // The data that comes from the API for a stashed cart includes:
        // branchID
        // createdAt
        // deletedAt
        // deviceID
        // guid
        // stashedCartData - This is the actual payload for the cart contents.
        // stashedCartID
        // thirdPartyID
        // updatedAt
        // user
        // userID
        // username

        // First build an object with all the data at the same level.
        try {
            // FIXME: This is ugly, don't do this.
            let stashedCartData = Object.assign(data.stashedCartData, data);
            // Then apply that data to a StashedCart model.
            this.hydrator.hydrate(stashedCartData, stashedCart);
        } catch (err) {
            console.warn('There was a problem with the stashedCartData', err, data);
        }

        return stashedCart;
    },

    sortStashedCarts: function (stashedCarts) {
        let username = this.userService.getUsername();
        stashedCarts.sort(function (ele1, ele2) {
            // Sort by username first.
            if (ele1.username && ele2.username) {
                if (ele1.username === username && ele2.username !== username) {
                    return -1;
                }
                if (ele1.username !== username && ele2.username === username) {
                    return 1;
                }
            }
            // Usernames are the same, so sort by date/time stashed
            if (ele1.stashDatetime === ele2.stashDatetime) {
                return 0;
            }

            return (ele1.stashDatetime < ele2.stashDatetime ? 1 : -1);
        });
    },
};

module.exports = CartStashHelper;
